import { SvgIconProps } from '@mui/material'

import { useFestiveVariants } from '@dhl/utils'

import { TruckDefault } from './TruckDefault.js'
import { TruckChristmas } from './TruckChristmas.js'
import { TruckEaster } from './TruckEaster.js'

export const Truck: React.FC<SvgIconProps> = (props) => {
  const Component = useFestiveVariants({
    christmas: TruckChristmas,
    default: TruckDefault,
    easter: TruckEaster,
  })

  return <Component {...props} />
}
